export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY;
export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION
export const COGNITO_USERPOOL_ID = process.env.REACT_APP_COGNITO_USERPOOL_ID
export const COGNITO_USERPOOL_WEB_CLIENT_ID = process.env.REACT_APP_COGNITO_USERPOOL_WEB_CLIENT_ID
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN
export const COGNITO_SIGN_IN_URL = process.env.REACT_APP_COGNITO_SIGN_IN_URL
export const COGNITO_SIGN_OUT_URL = process.env.REACT_APP_COGNITO_SIGN_OUT_URL
const HTTPS = "https://";

export const CONFIG_API_URL = HTTPS + API_GATEWAY;